// extracted by mini-css-extract-plugin
module.exports = {"SearchHero":"styles-module--SearchHero--3sFSF","container":"styles-module--container--1NyRR","compact":"styles-module--compact--2YrpD"};